export default "__VITE_ASSET__xoTv1yRT__"